import { render } from "./Comments.vue?vue&type=template&id=9afda39a&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=9afda39a&scoped=true&lang=css"
import "./Comments.vue?vue&type=style&index=1&id=9afda39a&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9afda39a"]])

export default __exports__